import clsx from 'clsx';

import EditableField from '~components/generic/editable-field/EditableField/EditableField';
import AddLink from '~components/generic/elements/add-link/AddLink';
import DraggableModuleContainer from '~components/generic/module/DraggableModuleContainer';
import { ModuleAttachments } from '~components/generic/module-attachments/ModuleAttachments';
import { IEntityComponentProps } from '~interfaces/props';
import { getRelatedEntityIds } from '~services/entity-helpers';
import { getModuleUrlIdFromData } from '~services/location-helpers';

export const ModulePalette = ({
  data,
  editing,
  className,
  onChange,
  onAddNewChild,
  origData,
  stable,
}: IEntityComponentProps) => {
  if (!data) {
    return null;
  }

  const displayType: number = data.attributes?.field_display_type || 2;
  const hideTitle: boolean = data.attributes?.field_hide_title || false;
  const title: string = data.attributes?.field_title?.value || null;
  const hideText: boolean = data.attributes?.field_hide_text || false;
  const text: string = data.attributes?.field_text?.value || null;

  const childModuleIds = getRelatedEntityIds(data, 'field_colors');
  const childModuleIdsLength = childModuleIds.length - 1;

  const clsModule = clsx({ ...className.module }, 'relative');
  const clsContainer = clsx({ ...className.container }, 'px-0 relative');
  const clsItem = clsx({
    'c-color--list col-md-12': displayType === 1,
    'c-color--card col-xl-4 col-md-6': displayType !== 1,
    'col-sm-6': true,
  });

  const clsHeader = clsx('c-module__header row');
  const clsContent = clsx('c-module__content row d-flex flex-wrap');
  const clsText = clsx('o-field-text col col-md-8');
  const clsTextContainer = clsx('u-margin-top-sm col col-12');
  const clsColorsContainer = clsx('u-margin-top-md col col-12');
  const clsColors = clsx('row d-flex flex-wrap');

  return (
    <div className={clsModule} id={getModuleUrlIdFromData(data.id, data.type)}>
      <div className={clsContainer}>
        <div className={clsHeader}>
          <div className={'col col-12'}>
            <EditableField
              hide={hideTitle}
              entityType={data.type}
              fieldName="attributes.field_title.value"
              data={title}
              editing={editing}
              onChange={onChange}
            />
          </div>
          <ModuleAttachments data={data} />
        </div>
        <div className={clsContent}>
          {!!text && (
            <div className={clsTextContainer}>
              <div className={'row'}>
                <div className={clsText}>
                  <EditableField
                    hide={hideText}
                    entityType={data.type}
                    fieldName="attributes.field_text.value"
                    data={text}
                    editing={editing}
                    onChange={onChange}
                  />
                </div>
              </div>
            </div>
          )}
          <div className={clsColorsContainer}>
            <div className={clsColors}>
              {childModuleIds.map((id, i) => (
                <div key={id} className={clsItem}>
                  <DraggableModuleContainer
                    parentIsStable={stable}
                    index={i}
                    entityId={id}
                    parentContext={data.id}
                    parentType={data.type}
                    fieldName="relationships.field_colors.data"
                    siblingsLength={childModuleIdsLength}
                    canMove={editing}
                  />
                </div>
              ))}
            </div>
            {editing && (
              <AddLink
                onClick={() =>
                  onAddNewChild({
                    id: origData,
                    fieldName: 'relationships.field_colors.data',
                    templateType: 'paragraph--palette_item',
                  })
                }
              />
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ModulePalette;
